import type { createLocalArticleApi } from './localArticles';
import type { createLocalBusinessApi } from './localBusiness';
import type { createLocalEventApi } from './localEvents';

const token = /^[A-Za-z0-9_-]{43}$/;
// One private homepage preview that carries both service tokens in the URL fragment; the tokens never reach a server request.
export async function createHomepagePreviewUrl(kwuid: string, articles: ReturnType<typeof createLocalArticleApi>, businesses: ReturnType<typeof createLocalBusinessApi>, events?: ReturnType<typeof createLocalEventApi>) {
  if (!/^[0-9]{3,12}$/.test(kwuid)) throw new Error('Preview identity unavailable');
  const [articleToken, businessToken] = await Promise.all([articles.previewToken(), businesses.previewToken()]);
  if (!token.test(articleToken) || !token.test(businessToken)) throw new Error('Private preview destination invalid');
  const eventToken = events ? await events.previewToken() : null;
  if (eventToken && !token.test(eventToken)) throw new Error('Private Event preview destination invalid');
  return `http://127.0.0.1:4294/${kwuid}#local-articles-preview=${articleToken}&local-business-preview=${businessToken}${eventToken ? `&local-events-preview=${eventToken}` : ''}`;
}
